import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import { AdminAuthProvider } from './auth/AdminAuthContext';
import { AdminStoreProvider } from './context/adminStore';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AdminAuthProvider>
      <AdminStoreProvider>
        <App />
      </AdminStoreProvider>
    </AdminAuthProvider>
  </React.StrictMode>
);
